// Business details used by the User Agreement and Privacy Policy. Change them
// here and both documents update. Bump EFFECTIVE_DATE whenever either
// document's substance changes.
export const LEGAL_ENTITY = 'Gradiess LLC';
export const LEGAL_STATE = 'New Jersey';
export const LEGAL_EMAIL = 'michael@gradies.com';
export const EFFECTIVE_DATE = 'October 19, 2026';

// Claim windows for the refund policy (User Agreement section 6).
export const NOT_RECEIVED_DAYS = 30; // from the order date
export const NOT_AS_DESCRIBED_DAYS = 7; // from delivery
export const REFUND_BUSINESS_DAYS = 10; // to issue an approved refund
